import React, { useEffect, useState } from 'react'
import apiService from '../../services/apiServices'
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import { jsPDF } from "jspdf";
import EmployeeCardPdf from './EmployeeCardPdf';
import { Bars } from 'react-loader-spinner'

const EmployeeCard = (props) => {
    const [loader, setLoader] = useState(true);
    const [employeeCard, setEmployeeCard] = useState();
    const months = [
        { no: 1, name: 'Janar' },
        { no: 2, name: 'Shkurt' },
        { no: 3, name: 'Mars' },
        { no: 4, name: 'Prill' },
        { no: 5, name: 'Maj' },
        { no: 6, name: 'Qershor' },
        { no: 7, name: 'Korrik' },
        { no: 8, name: 'Gusht' },
        { no: 9, name: 'Shtator' },
        { no: 10, name: 'Tetor' },
        { no: 11, name: 'Nentor' },
        { no: 12, name: 'Dhjetor' }
    ]

    const getEmployeeCard = (id) => {
        apiService().query("employeeCard", "id=" + id)
            .then(response => {
                //setEmployeeCard(response.data[response.data.length - 1]);
                getEmployeeHolidays(response.data[response.data.length - 1])
            })
    }

    const getEmployeeHolidays = (obj) => {
        apiService().query("getEmployeesHolidays", "id=" + obj.Id)
            .then(response => {
                if (response.success) {
                    obj["holidays"] = response.data;
                    let days = 0, holidaysWithoutPay = 0, holidaysWithPay = 0, martialHoliday = 0, medicalHoliday = 0, otherHoliday = 0;
                    for (var i = 0; i < obj.holidays.length; i++) {
                        if (obj.holidays[i].HolidayType === 4) {
                            holidaysWithoutPay += parseFloat(obj.holidays[i].holidayDays);
                        }
                        else {
                            holidaysWithPay += parseFloat(obj.holidays[i].holidayDays);
                        }
                        days += parseFloat(obj.holidays[i].holidayDays);

                        if (obj.holidays[i].HolidayType === 3) {
                            martialHoliday += parseFloat(obj.holidays[i].holidayDays);
                        }
                        if (obj.holidays[i].HolidayType === 2) {
                            medicalHoliday += parseFloat(obj.holidays[i].holidayDays);
                        }
                        if (obj.holidays[i].HolidayType === 5) {
                            otherHoliday += parseFloat(obj.holidays[i].holidayDays);
                        }
                    }
                    obj["days"] = days;
                    obj["holidaysWithoutPay"] = holidaysWithoutPay;
                    obj["holidaysWithPay"] = holidaysWithPay;
                    obj["martialHoliday"] = martialHoliday;
                    obj["medicalHoliday"] = medicalHoliday;
                    obj["otherHoliday"] = otherHoliday;
                    obj["allHolidays"] = 20;
                    getWorkerSalaries(obj)
                }
                else {
                    setEmployeeCard(obj);
                }
            })
    }

    const getWorkerSalaries = (obj) => {
        apiService().query("getWorkerSalary", "workerId=" + obj.Id)
            .then(response => {
                if (response.success) {
                    obj["salaries"] = response.data;
                    //setEmployeeCard(obj);
                    getFiscalPolitics(obj);
                }

            })
    }

    const getFiscalPolitics = (obj) => {
        apiService().get('fiscalPolitics')
            .then(response => {
                if (response.success) {
                    getFiscalpoliticsDetails(response?.data[0]?.Id, obj)
                }
            })
    }

    const getFiscalpoliticsDetails = (id, obj) => {
        apiService().query('getFiscalpoliticsDetails', `FiscalPoliticsId=${id}`)
            .then(response => {
                if (response.success) {
                    prepareEmployeeCard(response.data, obj)
                }
            })
    }

    const prepareEmployeeCard = (fiscalRanges, obj) => {
        let ec = obj;

        ec?.salaries?.forEach(salary => {
            salary["employeeTaxFee"] = (ec?.EmployeeTax / 100) * salary?.Salary
            salary["employerTaxFee"] = (ec?.EmployerTax / 100) * salary?.Salary
            salary["contributions"] = (ec?.EmployerTax / 100) * salary?.Salary + (ec?.EmployeeTax / 100) * salary?.Salary

            salary["taxes"] = calcualateTaxes(salary?.Salary - ((ec?.EmployeeTax / 100) * salary?.Salary), fiscalRanges)
            salary["neto"] = (salary?.Salary - ((ec?.EmployeeTax / 100) * salary?.Salary)) - calcualateTaxes(salary?.Salary - ((ec?.EmployeeTax / 100) * salary?.Salary), fiscalRanges)
            salary["total"] = (salary?.Salary - ((ec?.EmployeeTax / 100) * salary?.Salary)) - calcualateTaxes(salary?.Salary - ((ec?.EmployeeTax / 100) * salary?.Salary), fiscalRanges) + salary?.Bonus

        });
        setEmployeeCard(ec)
        setLoader(false)
    }

    const calcualateTaxes = (salary, fiscalRanges) => {
        let total = 0;
        for (let i = 0; i < fiscalRanges?.length; i++) {
            if (salary > fiscalRanges[i].To) {
                if (fiscalRanges[i].To !== null) {
                    total += (fiscalRanges[i].To - fiscalRanges[i].From) * fiscalRanges[i].Tax / 100;
                }
                else {
                    if (salary > fiscalRanges[i].From) {
                        total += (salary - fiscalRanges[i].From) * fiscalRanges[i].Tax / 100;
                    }
                }
            }
            else {
                if (salary > fiscalRanges[i].From && salary < fiscalRanges[i].To) {
                    total += (salary - fiscalRanges[i].From) * fiscalRanges[i].Tax / 100
                }
            }
        }
        return total
    }


    const toPdf = (fileName) => {
        var doc = new jsPDF("p", "", "a4");
        var elementHTML = document.getElementById("contentTable");

        doc.html(elementHTML, {
            callback: function (doc) {
                doc.save(fileName ? fileName + '.pdf' : 'document.pdf');
            },
            x: 5,
            y: 5,
            width: 200, //target width in the PDF document
            windowWidth: 1000 //window width in CSS pixels
        });
    }

    useEffect(() => {
        getEmployeeCard(props?.match?.params?.id);
    }, [])

    return (
        <div>
            {loader && <div className="loader-class"><Bars
                height="70"
                width="100%"
                color="#1976d2"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            /></div>}
            {!loader &&
                <>
                    <TopActions downloadContract={() => toPdf(employeeCard?.FirstName + "_" + employeeCard?.LastName)} />
                    <Grid xs={12} sm={8} lg={8}>
                        <TableContainer component={Paper}>
                            {employeeCard && <EmployeeCardPdf employeeCard={employeeCard} />}
                        </TableContainer>
                    </Grid>
                </>
            }
        </div>
    )
}

export default EmployeeCard